import React, { useRef } from 'react';
var VeltNotificationsPanelContentListItemUnread = function (props) {
    var notification = props.notification, isDefault = props.isDefault, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-list-item-unread", { ref: ref, notification: notification ? (typeof notification === "string" ? notification : JSON.stringify(notification)) : undefined, "is-default": [true, false].includes(isDefault) ? (isDefault ? 'true' : 'false') : undefined }, children));
};
export default VeltNotificationsPanelContentListItemUnread;
